import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withIcon } from '../Icon';
export var SquareFeetOutlineSVG = function SquareFeetOutlineSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,13.5859V23h9.4141Zm2,4.8282L12.5856,21H10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.39,25.56,5.39,3.54a1.9767,1.9767,0,0,0-1.38-.56H4a2.0049,2.0049,0,0,0-2,2V28a1.0029,1.0029,0,0,0,1,1H28a1.9917,1.9917,0,0,0,2-2A1.9163,1.9163,0,0,0,29.39,25.56ZM23,27V26a1,1,0,0,0-2,0v1H18V26a1,1,0,0,0-2,0v1H13V26a1,1,0,0,0-2,0v1H8V26a1,1,0,0,0-2,0v1H4L4.01,5,28,27Z"
  })));
};
SquareFeetOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
SquareFeetOutlineSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Square Feet")
};
export default withIcon(SquareFeetOutlineSVG);